import { render, staticRenderFns } from "./ExportacaoParaExcel.vue?vue&type=template&id=16e6dc64&scoped=true"
import script from "./ExportacaoParaExcel.vue?vue&type=script&lang=js"
export * from "./ExportacaoParaExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e6dc64",
  null
  
)

export default component.exports